import React, { useState, useEffect, useCallback } from 'react';
import { Spinner, Row, Col, Button } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showCompanyTaskRequest, updateCompanyTaskRequest } from '../../requests/companyTasks';
import { LinkBtn, Icon, DefaultModal, FormikInput } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { sendAlert } from '../../actions/utils';
import basicTask from '../Shared/CompanyTask/task';
import CompanyTaskInfoShow from '../Profile/CompanyTask/CompanyTaskInfoShow';

const CompanyTaskShow = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const [task, setTask] = useState(camelCaseEmptyStringRecursive(basicTask));
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [comment, setComment] = useState('');

  const fetchTask = useCallback(() => {
    setLoading(true);
    showCompanyTaskRequest(id, {
      dispatch,
      successCallback: response => {
        setTask(camelCaseEmptyStringRecursive(response.data));
        setLoading(false);
      },
      failureCallback: () => {
        setLoading(false);
        history.push('/tasks');
        dispatch(sendAlert({ kind: 'error', message: 'Tarea no encontrada' }));
      }
    });
  }, [dispatch, history, id]);

  const handleAddComment = () => {
    if (!comment) return;
    setLoading(true);
    const params = {
      company_task: {
        company_task_comments_attributes: [{ comment }]
      }
    };
    updateCompanyTaskRequest(id, {
      dispatch,
      params,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Comentario agregado con éxito' }));
        setModalShow(false);
        setComment('');
        fetchTask();
      },
      failureCallback: () => setLoading(false)
    });
  };

  useEffect(() => {
    fetchTask();
  }, [fetchTask]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading && !task.id) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Row className="mt-4 mb-4 align-items-center">
        <Col xs="auto">
          <LinkBtn variant="circle-dark" className="btn-circle" to="/tasks">
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>
        <Col>
          <h2 className="text-uppercase mb-0">Detalle de la Tarea</h2>
        </Col>
      </Row>

      <Row className="justify-content-end mb-4">
        <Col xs="auto">
          <Button variant="primary" onClick={() => setModalShow(true)}>
            AGREGAR COMENTARIO
          </Button>
        </Col>
      </Row>

      <CompanyTaskInfoShow task={task} />

      <DefaultModal
        title="AGREGAR COMENTARIO"
        body={
          <FormikInput
            as="textarea"
            label="Comentario"
            maxLength={300}
            value={comment}
            onChange={e => setComment(e.target.value)}
          />
        }
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleConfirm={handleAddComment}
        titleBtnSave="AGREGAR COMENTARIO"
        variantBtnSave="primary"
        withConfirm
        disabled={loading || !comment}
      />
    </>
  );
};

export default CompanyTaskShow;
